"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const ProgressBar = ({
  value,
  completed,
  completedText,
  textStyles,
  completedColor,
  inCompletedColor,
  ...rest
}) => {
  const isCompleted = completed || parseInt(value) >= 100;
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: "progress-track-container"
  }, rest), /*#__PURE__*/_react.default.createElement("span", {
    className: "progress-text",
    style: textStyles
  }, isCompleted ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, " ", completedText, " ", /*#__PURE__*/_react.default.createElement("i", {
    className: "done-icon ri-check-line "
  }), " ") : value !== null && `${value}%`), /*#__PURE__*/_react.default.createElement("div", {
    className: "progress-track",
    style: {
      backgroundColor: inCompletedColor
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "bar-tracker",
    style: {
      width: `${value}%`,
      backgroundColor: completedColor
    }
  })));
};

ProgressBar.propTypes = {
  value: _propTypes.default.number,
  completed: _propTypes.default.bool,
  completedText: _propTypes.default.string,
  textStyles: _propTypes.default.object,
  completedColor: _propTypes.default.string,
  inCompletedColor: _propTypes.default.string
};
ProgressBar.defaultProps = {
  value: 100,
  completed: false,
  completedText: "Done"
};
var _default = ProgressBar;
exports.default = _default;